var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scan"},[_c('img',{attrs:{"src":require("@/assets/images/scan-code-login.png"),"alt":_vm.$t('i18n.signInWithQRCode')}}),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('i18n.pleaseUseAppToScanAndSignIn'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }